import { Badge } from "@/components/ui/badge";
import { label } from "@/lib/api";

const TONE = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  danger: "bg-rose-50 text-rose-700 border-rose-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  muted: "bg-slate-100 text-slate-600 border-slate-200",
};

const STATUS_TONE = {
  new: "info", attempting: "warning", callback_scheduled: "info", contacted: "success", resolved: "success",
  do_not_call: "danger", opted_out: "danger", wrong_number: "danger",
  in_progress: "success", ringing: "warning", queued: "warning", awaiting_browser: "warning", completed: "muted",
  no_answer: "muted", busy: "muted", failed: "danger", canceled: "muted", missed: "danger",
  conversation: "success", callback_requested: "info", not_interested: "muted", voicemail: "muted", left_voicemail: "muted",
  agent_unavailable: "warning", no_conversation: "muted", available: "success", offline: "muted",
  active: "success", paused: "warning", stopped: "muted",
};

export const StatusBadge = ({ value, tone, testId, children }) => (
  <Badge variant="outline" data-testid={testId} className={`rounded-full font-medium text-[11px] px-2 py-0.5 whitespace-nowrap ${TONE[tone || STATUS_TONE[value] || "muted"]}`}>
    {children || label(value)}
  </Badge>
);

export const Dot = ({ on, warn }) => (
  <span className={`inline-block h-2 w-2 rounded-full ${on ? "bg-emerald-500" : warn ? "bg-amber-500" : "bg-slate-300"}`} />
);

export const Field = ({ label: l, children, hint }) => (
  <label className="block space-y-1">
    <span className="text-xs font-medium text-slate-600">{l}</span>
    {children}
    {hint && <span className="block text-[11px] text-slate-400">{hint}</span>}
  </label>
);

export const PageHeader = ({ title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-3">
    <div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
      {sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
